import * as React from 'react';
import { BottomSheetAnimatedInstance } from './BottomSheetAnimatedWrapper';
import { BottomSheetAnimatedStatefulProps } from '../schema/BottomSheetAnimatedProps';

interface BottomSheetAnimatedState {
    sheetOpen: boolean;
}

/**
 * Stateful version of the animated bottomsheet that can be opened/closed using a ref.
 * This does not a have Portal variant, yet - so you will need to use this with the
 * associated utils.
 */
export class BottomSheetAnimatedStateful extends React.Component<
    BottomSheetAnimatedStatefulProps,
    BottomSheetAnimatedState
> {
    constructor(props: BottomSheetAnimatedStatefulProps) {
        super(props);
        this.state = { sheetOpen: false };
    }

    open() {
        this.setState({ sheetOpen: true });
    }

    close() {
        this.setState({ sheetOpen: false });
    }

    render() {
        const { open: _, onOverlayClick, hideOnOverlayClick, ...remainingProps } = this.props;
        const onOverlayClickWrapper = () => {
            hideOnOverlayClick && this.close();
            onOverlayClick && onOverlayClick();
        };
        return (
            <BottomSheetAnimatedInstance
                open={this.state.sheetOpen}
                onOverlayClick={onOverlayClickWrapper}
                {...remainingProps}
            />
        );
    }
}

export default BottomSheetAnimatedStateful;
